module.exports = __webpack_public_path__ + "static/media/b-sci-major-16_LR.a4a21814.jpg";